import type { ReplaceIdsFromSnapshot } from '../interactivityActionSnapshotMetadata';
import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';
import type { ControlAnimationInteractivityActionSnapshotOut } from './ControlAnimationInteractivityAction';

const replaceTargetRefIdsFromSnapshot: ReplaceIdsFromSnapshot<
  ControlAnimationInteractivityActionSnapshotOut
> = (snapshot, replaceId) => {
  if (snapshot.targetRefId) {
    snapshot.targetRefId = replaceId(snapshot.targetRefId);
  }
};

export const controlAnimationInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.ControlAnimation,
  replaceTargetRefIdsFromSnapshot,
};
